/**
 * @file NotificationTemplateEmailTab.js
 * @description Email body editor for the multitenant notification template editor's Message Preview.
 */
import RichTextEditor from '../../new-portal-page/RichTextEditor';

const NotificationTemplateEmailTab = ({
    initialHtmlBody,
    onHtmlBodyChange,
    isReadOnly,
    agencyId = null,
}) => {
    return (
        <div
            style={{
                opacity: isReadOnly ? 0.6 : 1,
                pointerEvents: isReadOnly ? 'none' : 'auto',
            }}
        >
            <RichTextEditor
                initialContent={initialHtmlBody}
                onContentUpdate={onHtmlBodyChange}
                disableSSO={true}
                disablePortalLink={true}
                disableMenu={true}
                disableAssetLink={true}
                useAbsoluteLinks={true}
                agencyId={agencyId}
                onAssetDelete={null}
            />
        </div>
    );
};

export default NotificationTemplateEmailTab;
